import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: {
    id: 'app.containers.app.action.cancel',
    defaultMessage: 'CANCEL',
  },
  close: {
    id: 'app.containers.app.action.close',
    defaultMessage: 'CLOSE',
  },
  confirm: {
    id: 'app.containers.app.action.confirm',
    defaultMessage: 'CONFIRM',
  },
  continue: {
    id: 'app.containers.app.action.continue',
    defaultMessage: 'CONTINUE',
  },
  no: {
    id: 'app.containers.app.action.no',
    defaultMessage: 'NO',
  },
  ok: {
    id: 'app.containers.app.action.ok',
    defaultMessage: 'OK',
  },
  retry: {
    id: 'app.containers.app.action.retry',
    defaultMessage: 'RETRY',
  },
  required_label: {
    id: 'app.containers.app.required.label',
    defaultMessage: 'Required',
  },
  must_be_positive: {
    id: 'app.containers.app.mustBePositive.label',
    defaultMessage: 'Must be positive',
  },
  wrongFormat: {
    id: 'app.containers.app.email.wrong-format',
    defaultMessage: 'Wrong format',
  },
  yes: {
    id: 'app.containers.app.action.yes',
    defaultMessage: 'YES',
  },
  enter_location: {
    id: 'app.containers.app.enter.location',
    defaultMessage: 'Please enter your location address',
  },
  enter_custom_address: {
    id: 'app.containers.app.enter.custom',
    defaultMessage: 'Please enter your custom address',
  },
  return: {
    id: 'app.containers.app.action.return',
    defaultMessage: 'Return',
  },
  favorite_addresses: {
    id: 'app.containers.app.edit.favorite-addresses',
    defaultMessage: 'Favorite addresses',
  },
  drivers_home: {
    id: 'app.containers.app.edit.drivers-home',
    defaultMessage: "Driver's home",
  },
  event_location: {
    id: 'app.containers.app.edit.event-location',
    defaultMessage: 'Event location',
  },
  parking_address: {
    id: 'app.containers.app.edit.parking-address',
    defaultMessage: 'Parking address',
  },
  must_be_number: {
    id: 'app.containers.app.form.must-be-number',
    defaultMessage: 'Must be number',
  },
  must_be_integer: {
    id: 'app.containers.app.form.must-be-integer',
    defaultMessage: 'Must be whole number',
  },
  must_be_between: {
    id: 'app.containers.app.form.must-be-at-least-1',
    defaultMessage: 'Driver must be between {minAge} and 99',
  },
  must_be_at_least: {
    id: 'app.containers.app.form.must-be-between-1',
    defaultMessage: 'Driving license must be valid for at least {yearLimit} years',
  },
  cannot_be_less_than_license_year: {
    id: 'app.containers.app.form.cannot-be-less-than-license-year',
    defaultMessage: 'Driving license year cannot be less than the minimum acquisition date',
  },
});
